import { Message } from "@/types";

import { axios } from "../axios.instance";

export type ViewOnceMessageRequest = {
  messageId: string;
};

export type ViewOnceMessageResponse = Message;

export const viewOnceMessage = async (body: ViewOnceMessageRequest): Promise<ViewOnceMessageResponse> => {
  const { data } = await axios.post(`/chats/messages/${body.messageId}/view-once`);

  return data;
};
